import { useEffect, useState } from "react";
import {
  ButtonContantUs,
  ButtonLocalData,
  ButtonMainInfo,
  ButtonSecurity,
  ContainerButton,
  ContainerSecurityPage,
  DangerZoneTitle,
  DeleteAccount,
  DeleteAccountUserContainer,
  FormChangePasswordContainer,
  HeaderSecurityPage,
  Languages,
  NewPasswordInput,
  NewRepeatPasswordInput,
  PasswordSaveButton,
  SecurityPageContainer,
  TitleChangePassword,
  TitleSecurePage,
  TwoFaButton,
  TwoFAContainer,
  TwoFATitle,
  NameUser,
  NicNameUserColor,
  ButtonBackPage,
  TitlePage,
  ContainerIncludeValidationPassword,
  IndicatorPasswordValidation,
  PolicyPrivacyButton,
  PolicyPrivacyButtonContainer,
  ButtonCredits,
} from "./SecurityPageStyles.styled";
import useAuth from "../../../Redux/useAuth";
import { useLanguageContext } from "../../../Components/Languages/Langs/LanguageContext";
import { NavLink } from "react-router-dom";
import { ModelWindow } from "../../../Components/ModelWindow/ModelWindow";
import { Logout } from "../../../Components/ModelWindows/Logout/Logout";
import { ModelWindowAccount } from "./ModelWindowAccount/ModelWindowAccount";
import { ButtonLogOut } from "../../../Components/ModelWindows/Logout/LogOut.styled";
import { ButtonBackPageIcon } from "../../MainInfo/Icons/Icons";
import { UpdateQRCode } from "../../../Components/ModelWindows/UpdateQRCode/UpdateQRCode";
import { ModelUpdateQRCode } from "../../../Components/ModelUpdateQRCode/ModelUpdateQRCode";
import { useAppDispatch } from "../../../Redux/store";
import { UpdateUserPassword } from "../../../Redux/Auth/operations";
import { ErrorTextUser } from "../../../Components/Public/WelcomePage/Header/SignUpModel/SignUpModelStyles.styled";
import { ResetPasswordAccount } from "../../../Components/Public/WelcomePage/Header/TypeErrors";
import { toast } from "react-toastify";
import { PolicyPrivacyModel } from "./PolicyPrivacyModel/PolicyPrivacyModel";

// fix: after success changed password redirect on sign-in

export const SecurityPage = () => {
  const { user, idUser } = useAuth();
  const { t } = useLanguageContext();
  const dispatch = useAppDispatch();

  const [openModelLogOut, setOpenModelLogOut] = useState<boolean>(false);
  const [showLogOut, setShowLogOut] = useState<boolean>(false);

  const openLogOut = () => {
    setShowLogOut(true);
    setTimeout(() => setOpenModelLogOut(true), 0);
  };

  const closeLogOut = () => {
    setOpenModelLogOut(false);
    setTimeout(() => setShowLogOut(false), 250);
  };

  const [openModelAccount, setOpenModelAccount] = useState<boolean>(false);
  const [showModelAccount, setShowModelAccount] = useState<boolean>(false);

  const openModelDeleteAccountUser = () => {
    setShowModelAccount(true);
    setTimeout(() => setOpenModelAccount(true), 0);
  };

  const closeModelDeleteAccountUser = () => {
    setOpenModelAccount(false);
    setTimeout(() => setShowModelAccount(false), 250);
  };

  // update password
  const [formErrorResetPassword, setFormErrorResetPassword] =
    useState<ResetPasswordAccount>({});
  const [hasTriedSubmit, setHasTriedSubmit] = useState<boolean>(false);
  interface PasswordStrength {
    label: string;
    value: number;
    color: string;
  }

  const [strength, setStrength] = useState<PasswordStrength | null>(null);
  const [updatePasswordUserAccount, setUpdatePasswordUserAccount] = useState({
    password: "",
    confirmPassword: "",
  });

  const [checkPasswordInput, setCheckPasswordInput] = useState("");

  const filled = !!checkPasswordInput.trim();
  const updatePasswordUser = async (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    setHasTriedSubmit(true);

    try {
      if (!idUser) {
        console.error("User ID is missing");
        return;
      }
      const form = evt.currentTarget;
      const formData = new FormData(form);
      const password = formData.get("password") as string;
      const confirmPassword = formData.get("confirmPassword") as string;

      await dispatch(
        UpdateUserPassword({
          id: idUser,
          password,
          confirmPassword,
        }),
      ).unwrap();
    } catch (err) {
      if (typeof err === "object" && err !== null) {
        const typedError = err as ResetPasswordAccount;
        setFormErrorResetPassword(typedError);
      } else {
        toast.error("Something went wrong in sign up. Try again later");
      }
    }
  };

  const evaluatePasswordStrength = (password: string) => {
    let score = 0;

    if (password.length >= 8) score++;
    if (password.length >= 12) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[a-z]/.test(password)) score++;
    if (/\d/.test(password)) score++;
    if (/[^A-Za-z0-9]/.test(password)) score++;

    if (score <= 2) {
      return {
        label: t("passwordInducator.strengthWeak"),
        value: 25,
        color: "#ff4d4d",
      }; // red
    }

    if (score <= 4) {
      return {
        label: t("passwordInducator.strengthMedium"),
        value: 50,
        color: "#ffa600",
      }; // orange
    }

    if (score === 5) {
      return {
        label: t("passwordInducator.strengthStrong"),
        value: 75,
        color: "#0099ff",
      }; // blue
    }

    return {
      label: t("passwordInducator.strengthStronger"),
      value: 100,
      color: "#00cc66",
    }; // green
  };

  // update QRCode

  const [showQRCodeModel, setShowQRCodeModel] = useState<boolean>(() => {
    return localStorage.getItem("showQRCodeModel") === "true";
  });

  const [openQRCodeModel, setOpenQRCodeModel] = useState<boolean>(() => {
    return localStorage.getItem("showQRCodeModel") === "true";
  });

  const openModelUpdate = () => {
    setShowQRCodeModel(true);
    setTimeout(() => setOpenQRCodeModel(true), 0);
    localStorage.setItem("showQRCodeModel", "true");
  };

  const closeModelUpdate = () => {
    setOpenQRCodeModel(false);
    setTimeout(() => setShowQRCodeModel(false), 250);
    localStorage.setItem("showQRCodeModel", "false");
  };

  // Відновлення стану після перезавантаження
  useEffect(() => {
    const savedState = localStorage.getItem("showQRCodeModel");
    if (savedState === "true") {
      setShowQRCodeModel(true);
      setOpenQRCodeModel(true);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("showQRCodeModel", showQRCodeModel ? "true" : "false");
  }, [showQRCodeModel]);

  // Policy Privacy model

  const [policyPrivacyModelOpen, setPolicyPrivacyModelOpen] =
    useState<boolean>(false);
  const [policyPrivacyModelShow, setPolicyPrivacyModelShow] =
    useState<boolean>(false);

  const openPolicyPrivacyUserModel = () => {
    setPolicyPrivacyModelShow(true);
    setTimeout(() => setPolicyPrivacyModelOpen(true), 0);
  };

  const closePolicyPrivacyUserModel = () => {
    setPolicyPrivacyModelShow(false);
    setTimeout(() => setPolicyPrivacyModelOpen(false), 250);
  };

  return (
    <>
      <HeaderSecurityPage>
        <NavLink to={`/home-page/${user?.name?.toLowerCase()}`}>
          <ButtonBackPage>
            <ButtonBackPageIcon />
          </ButtonBackPage>
        </NavLink>
        <NameUser>
          {t("privateTraslate.privateHeaderNameUser")}
          <NicNameUserColor> {user?.name || "User"}</NicNameUserColor>
        </NameUser>
        <TitlePage>{t("privateTraslate.securityPageTitle")}</TitlePage>
      </HeaderSecurityPage>

      <ContainerSecurityPage>
        <ContainerButton>
          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/main-info`}>
            <ButtonMainInfo>
              {t("privateTraslate.updateDataUserPageTitle")}
            </ButtonMainInfo>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/security-page`}>
            <ButtonSecurity>
              {t("privateTraslate.securityPageTitle")}
            </ButtonSecurity>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/languages`}>
            <Languages>{t("privateTraslate.languagesPageTitle")}</Languages>
          </NavLink>

          {/* <NavLink to={`/home-page/${user?.name?.toLowerCase()}/modes`}>
                        <ButtonModes>{t("privateTraslate.ModesPage")}</ButtonModes>
                    </NavLink> */}

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/local-data`}>
            <ButtonLocalData>
              {t("privateTraslate.LocalDataPage")}
            </ButtonLocalData>
          </NavLink>

          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/contacts`}>
            <ButtonContantUs>
              {t("privateTraslate.contactUsPageTitle")}
            </ButtonContantUs>
          </NavLink>
          <NavLink to={`/home-page/${user?.name?.toLowerCase()}/credits`}>
            <ButtonCredits>{t("privateTraslate.ButtonCredit")}</ButtonCredits>
          </NavLink>

          <ButtonLogOut onClick={openLogOut}>
            {t("privateTraslate.logOutButton")}
          </ButtonLogOut>
        </ContainerButton>

        <SecurityPageContainer>
          <TitleSecurePage>{t("privateTraslate.securityPage")}</TitleSecurePage>
          <TwoFAContainer>
            <TwoFATitle>{t("privateTraslate.securityPageTWA")}</TwoFATitle>
            <TwoFaButton type="button" onClick={openModelUpdate}>
              {t("privateTraslate.securityPageTWAButtonUpdate")}
            </TwoFaButton>
          </TwoFAContainer>
          <TitleChangePassword>
            {t("privateTraslate.securityPageChangePasswordTitle")}
          </TitleChangePassword>
          <FormChangePasswordContainer onSubmit={updatePasswordUser}>
            <NewPasswordInput
              type="text"
              name="password"
              placeholder={t("privateTraslate.securityPageChangePasswordEntry")}
              onChange={(evt) => {
                const value = evt.target.value;
                setCheckPasswordInput(evt.target.value);

                setUpdatePasswordUserAccount((prev) => ({
                  ...prev,
                  password: value,
                }));

                if (!value) {
                  setStrength(null);
                  return;
                }

                const strengthValue = evaluatePasswordStrength(value);
                setStrength(strengthValue);
              }}
              value={updatePasswordUserAccount.password}
            />
            <ErrorTextUser
              className={
                formErrorResetPassword.password && hasTriedSubmit
                  ? "error-animation"
                  : ""
              }
            >
              {formErrorResetPassword.password}
            </ErrorTextUser>
            <NewRepeatPasswordInput
              type="text"
              name="confirmPassword"
              placeholder={t(
                "privateTraslate.securityPageChangePasswordRepeatNew",
              )}
              onChange={(evt) => {
                const value = evt.target.value;
                setCheckPasswordInput(evt.target.value);

                setUpdatePasswordUserAccount((prev) => ({
                  ...prev,
                  confirmPassword: value,
                }));
              }}
              value={updatePasswordUserAccount.confirmPassword}
            />
            <ErrorTextUser
              className={
                formErrorResetPassword.confirmPassword && hasTriedSubmit
                  ? "error-animation"
                  : ""
              }
            >
              {formErrorResetPassword.confirmPassword}
            </ErrorTextUser>
            <ErrorTextUser
              className={
                formErrorResetPassword.samePassword && hasTriedSubmit
                  ? "error-animation"
                  : ""
              }
            >
              {formErrorResetPassword.samePassword}
            </ErrorTextUser>
            <ContainerIncludeValidationPassword>
              <IndicatorPasswordValidation
                width={strength?.value || 0}
                color={strength?.color || "#fff"}
              ></IndicatorPasswordValidation>
              <span>{strength?.label || ""}</span>
              <span>
                {t(
                  "publicTranslate.FormsAndModel.ModelSignUp.RecommendationText",
                )}{" "}
                {t(
                  "publicTranslate.FormsAndModel.ModelSignUp.RecomendationTitle",
                )}
              </span>
            </ContainerIncludeValidationPassword>
            <PasswordSaveButton
              $filled={filled}
              disabled={!filled}
              type="submit"
              value={t("privateTraslate.securityPageChangePasswordButtonSave")}
            />
          </FormChangePasswordContainer>
          <PolicyPrivacyButtonContainer>
            <PolicyPrivacyButton onClick={openPolicyPrivacyUserModel}>
              Policy Privacy
            </PolicyPrivacyButton>
          </PolicyPrivacyButtonContainer>
          <DeleteAccountUserContainer>
            <DangerZoneTitle>
              {t("privateTraslate.securityPageDeleteAccountTitle")}
            </DangerZoneTitle>
            <DeleteAccount type="button" onClick={openModelDeleteAccountUser}>
              {t("privateTraslate.securityPageDeleteAccountButton")}
            </DeleteAccount>
          </DeleteAccountUserContainer>
        </SecurityPageContainer>

        {showQRCodeModel && (
          <ModelUpdateQRCode
            onClose={closeModelUpdate}
            isOpen={openQRCodeModel}
          >
            <UpdateQRCode onClose={closeModelUpdate} />
          </ModelUpdateQRCode>
        )}

        {showLogOut && (
          <ModelWindow onClose={closeLogOut} isOpen={openModelLogOut}>
            <Logout onClose={closeLogOut} />
          </ModelWindow>
        )}

        {showModelAccount && (
          <ModelWindow
            onClose={closeModelDeleteAccountUser}
            isOpen={openModelAccount}
          >
            <ModelWindowAccount onClose={closeModelDeleteAccountUser} />
          </ModelWindow>
        )}

        {policyPrivacyModelShow && (
          <ModelWindow
            onClose={closePolicyPrivacyUserModel}
            isOpen={policyPrivacyModelOpen}
          >
            <PolicyPrivacyModel onClose={closePolicyPrivacyUserModel} />
          </ModelWindow>
        )}
      </ContainerSecurityPage>
    </>
  );
};
